// extracted by mini-css-extract-plugin
export default {"disclaimer":"CompanyDisclaimer_disclaimer__A22tT"};